export default () => {
  const $window = $(window);
  const $featureVideo = $('#js-video-bg');
  const videoBg = $('#js-video-bg');

  function loadVideo() {
    if(videoBg.length > 0) {
      $featureVideo.coverVid(1280, 820);

      if(window.innerWidth > mobileBreakpoint) {
        videoBg.on('canplaythrough', function() {
          if(!videoBg.hasClass('is-loaded')) {
            videoBg.addClass('is-loaded');
          }
        });
      }
    }
  }

  loadVideo();
};
